import React, { useEffect,  } from "react";
import { NavLink } from "reactstrap";
import useWindowSize from "../../../hooks/windowSize";
import { MOBILE_WIDTH } from "../../../constants/viewport.constants";
import { Translate } from "react-localize-redux";
import PhotoSearchCard from "../../PhotoSearchCard";
import { cookies } from "../../../utils/storage/CookieItem";
import "./styles.scss";


const ContactCardDetail = ({ contact, loggedInUser, loggedIn }) => {
  const size = useWindowSize();
  const isMobile = size.width <= MOBILE_WIDTH;

  const openInMobileApp = () => {
    window.location.replace('myhellohello://contact-card/' + contact.slug);
  };

  useEffect(() => {
    try {
      if (isMobile) {
        openInMobileApp();
      }
    } catch (e) {
      console.log(e);
    }
  }, [isMobile])

	return (
    <div
      id="page-container"
      className="row align-items-center justify-content-center"
    >
      <div id="contact-page-container">
          <NavLink href="/">
            <h3 id="sign-in-brand" className="brand-center">myHelloHello</h3>
          </NavLink>
          <br />
          {contact &&
            <PhotoSearchCard
              key={contact.id}
              rowItem={contact}
              isUserLoggedIn={loggedIn}
              loggedInUser={loggedInUser}
              fullCard={true}
              showContacts={false}
              showShare={true}
              showAddToCookie={true}
              onAdd={contactId => {
                cookies.set("contact-pre-join", contact.slug, {path: "/"});
                window.location.replace('/login');
              }}
            />
          }

          <br/>
          {!loggedIn &&
            <div className="row align-items-center justify-content-center">
              <br/>

              <p className="text-center">
                <NavLink href="/login" className="btn btn-primary sign-in-center">
                  <Translate id="signInText"/>
                </NavLink>

                <br />

                <Translate id="notInTheDirectory"/>
                <NavLink href="/register" className="sign-out-btn">
                  <Translate id="Joinhere"/>
                </NavLink>
              </p>

            </div>
          }
        </div>
    </div>
	);
}

export default ContactCardDetail;



// WEBPACK FOOTER //
// ./src/components/pages/ContactCardPage/ContactCardDetail.jsx